import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import ReactCollapse from 'react-collapse';
import { bindActionCreators } from 'redux';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, CurrencyFormats, Vehicle, ModelYear } from '@sm360/widget-commons-vehicle';
import { MEDIA_QUERIES, PriceAmounts } from '@sm360/widget-commons-general';

import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';
import BuildAndQuoteModel from 'build-and-quote/models/BuildAndQuoteModel.js';

import CalculatorTradein from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTradein/CalculatorTradein.jsx';
import CalculatorRebateStandardRate from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorRebateStandardRate/CalculatorRebateStandardRate.jsx';

import 'payment-calculator/components/PaymentCalculatorDetails/components/CashMethodPage/CashMethodPage.scss';

class CashMethodPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPurchaseDetail: false,
        };

        this.showPurchaseDetail = this.showPurchaseDetail.bind(this);
    }

    showPurchaseDetail() {
        this.setState({
            showPurchaseDetail: !this.state.showPurchaseDetail,
        });
    }

    render() {
        const { purchaseMethods, tradeInVehicle, actions, freightLabel } = this.props;
        const cashPurchaseAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
        const {
            modelTrim,
            taxAndDuty,
            freightPDI,
            otherFees,
            interiorColour,
            exteriorColour,
            options,
            protections,
            discounts,
            taxes,
            lien,
            tradeIn,
            rebates,
        } = cashPurchaseAmounts;

        const taxCodes = purchaseMethods.getTaxCodesString()
            ? purchaseMethods.getTaxCodesString()
            : LocaleService.t('PAYMENT_CALCULATOR.TAXES.TAXES');
        const totalMSRP = modelTrim + taxAndDuty + freightPDI + otherFees;
        const adjustedMSRP = totalMSRP + interiorColour + exteriorColour + options + protections;
        const sellPrice = adjustedMSRP - discounts;
        const totalToPay = sellPrice + taxes + lien - tradeIn - rebates;
        const accessoriesAmount = options + interiorColour;

        const purchaseDetailBlock = (
            <ul className="purchase-detail">
                <li className="purchase-detail-line clearfix">
                    <span className="label">
                        {' '}
                        {this.props.buildAndQuote
                            ? LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.SELL_PRICE')
                            : LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.OUR_PRICE')}
                    </span>
                    <span className="value">
                        <PriceAmounts price={LocaleService.l(adjustedMSRP, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </li>
                <li className="purchase-detail-line clearfix">
                    <span className="label rebate sr-paymentCalculator-EmphasisColor">
                        <icon className="icon-promo2 is-util" />
                        {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.CASH_DISCOUNT_BEFORE_TAXES')}
                    </span>
                    <span className="value is-util">
                        <PriceAmounts price={LocaleService.l(discounts, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </li>
                <li>
                    <hr />
                </li>
                <li className="purchase-detail-line clearfix sr-paymentCalculator-EmphasisColor">
                    <span className="label">
                        {this.props.buildAndQuote
                            ? LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.SELL_PRICE_WITH_DISCOUNTS')
                            : LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.PRICE_WITH_DISCOUNTS')}
                    </span>
                    <span className="value">
                        <PriceAmounts price={LocaleService.l(sellPrice, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </li>
                <li className="purchase-detail-line clearfix">
                    <span className="label"> {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.TRADEIN')} </span>
                    <span className="value">
                        <PriceAmounts price={LocaleService.l(tradeIn, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </li>
                <li className="purchase-detail-line clearfix sr-paymentCalculator-EmphasisColor">
                    <span className="label emphasis"> {taxCodes} </span>
                    <span className="value">
                        <PriceAmounts price={LocaleService.l(taxes, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </li>
                <li className="purchase-detail-line clearfix">
                    <span className="label emphasis">
                        {' '}
                        {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.LIEN')}
                    </span>
                    <span className="value">
                        <PriceAmounts price={LocaleService.l(lien, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </li>
                <li className="purchase-detail-line clearfix">
                    <span className="label rebate sr-paymentCalculator-EmphasisColor">
                        <icon className="icon-promo2 is-util" />
                        {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.CASH_DISCOUNT_AFTER_TAXES')}
                    </span>
                    <span className="value is-util">
                        <PriceAmounts price={LocaleService.l(rebates, CurrencyFormats.CURRENCY_2)} />
                    </span>
                </li>
            </ul>
        );

        const openSectionIcon = this.state.showPurchaseDetail
            ? 'icon-chevron-thin-down reverse'
            : 'icon-chevron-thin-down';

        return (
            <div className="purchase-methods-cash calculatorRow">
                <div className="calculatorColumn is-light pdsf_calculator">
                    <div className="price-wrapper clearfix sr-paymentCalculator-EmphasisColor">
                        <span className="price-title sr-subtitle-2 sr-paymentCalculator-EmphasisColor is-alternate">
                            <icon className="icon-review" />{' '}
                            {this.props.buildAndQuote
                                ? LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.BASE_PDSF')
                                : LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.REGULAR_PRICE')}
                        </span>
                        <span className="value">
                            <PriceAmounts price={LocaleService.l(modelTrim, CurrencyFormats.CURRENCY_2)} />
                        </span>
                    </div>
                    <ul className="purchase-detail">
                        <li className="purchase-detail-line clearfix">
                            <span className="label">
                                {' '}
                                {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.OTHER_FEES')}{' '}
                            </span>
                            <span className="value">
                                <PriceAmounts
                                    price={LocaleService.l(taxAndDuty + otherFees, CurrencyFormats.CURRENCY_2)}
                                />
                            </span>
                        </li>
                        <li className="purchase-detail-line clearfix">
                            <span className="label">
                                {' '}
                                {freightLabel || LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.PDI_FREIGHT')}{' '}
                            </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(freightPDI, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                        <li>
                            <hr />
                        </li>
                        <li className="purchase-detail-line clearfix sr-paymentCalculator-EmphasisColor">
                            <span className="label">
                                {' '}
                                {this.props.buildAndQuote
                                    ? LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.TOTAL_PDSF')
                                    : LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.TOTAL_PRICE')}{' '}
                            </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(totalMSRP, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                        <li className="purchase-detail-line clearfix">
                            <span className="label">
                                {' '}
                                {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.COLOR_FEE')}{' '}
                            </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(exteriorColour, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                        <li className="purchase-detail-line clearfix">
                            <span className="label">
                                {' '}
                                {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.ACCESSOIRES_OPTIONS')}{' '}
                            </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(accessoriesAmount, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                        <li className="purchase-detail-line clearfix">
                            <span className="label">
                                {' '}
                                {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.PROTECTIONS')}{' '}
                            </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(protections, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                        <li className="purchase-detail-line pdsf_total clearfix sr-paymentCalculator-EmphasisColor">
                            <span className="label emphasis">
                                {this.props.buildAndQuote
                                    ? LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.SELL_PRICE')
                                    : LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.OUR_PRICE')}
                            </span>
                            <span className="value">
                                <PriceAmounts price={LocaleService.l(adjustedMSRP, CurrencyFormats.CURRENCY_2)} />
                            </span>
                        </li>
                    </ul>
                </div>
                <div className="calculatorColumn is-light obligationsTotal">
                    <div
                        className="price-title sr-subtitle-2 sr-paymentCalculator-EmphasisColor is-alternate"
                        onClick={this.showPurchaseDetail}
                    >
                        {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.TOTAL_OBLIGATIONS')}
                        <icon className={openSectionIcon} />
                    </div>
                    <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                        <ReactCollapse isOpened={this.state.showPurchaseDetail}>{purchaseDetailBlock}</ReactCollapse>
                    </MediaQuery>
                    <MediaQuery minWidth={MEDIA_QUERIES.TABLET.MIN}>{purchaseDetailBlock}</MediaQuery>
                    <div className="purchase-detail-line price_total clearfix">
                        <span className="label sr-paymentCalculator-EmphasisColor">
                            {LocaleService.t('PAYMENT_CALCULATOR.PURCHASEMETHODS.TOTAL_TOPAY')}
                        </span>
                        <span className="value is-util">
                            <PriceAmounts price={LocaleService.l(totalToPay, CurrencyFormats.CURRENCY_2)} />
                        </span>
                    </div>
                    <div className="calculatorColumn__disclaimer">
                        {LocaleService.t('PAYMENT_CALCULATOR.DISCLAIMER')}
                    </div>
                </div>
                <div className="calculatorColumn">
                    <CalculatorTradein
                        tradeInVehicle={tradeInVehicle}
                        tradeIn={purchaseMethods.tradeIn}
                        lien={purchaseMethods.lien}
                        setTradeIn={actions.setTradeIn}
                        setLien={actions.setLien}
                        modelYear={this.props.modelYear}
                        setShiftEvent={actions.setShiftEvent}
                    />
                    <CalculatorRebateStandardRate stdRebate={purchaseMethods.getSelectedRebatesAtStandardRate()} />
                </div>
            </div>
        );
    }
}

CashMethodPage.defaultProps = {
    freightLabel: '',
};

CashMethodPage.propTypes = {
    buildAndQuote: PropTypes.instanceOf(BuildAndQuoteModel).isRequired,
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    actions: PropTypes.shape({
        setTradeIn: PropTypes.func.isRequired,
        setLien: PropTypes.func.isRequired,
    }),
    freightLabel: PropTypes.string,
};

CashMethodPage.displayName = 'CashMethodPage';

function mapStateToProps(state) {
    return {
        buildAndQuote: state.buildAndQuote,
        purchaseMethods: state.purchaseMethods,
        tradeInVehicle: state.tradeInVehicle,
        modelYear: state.modelYear,
        freightLabel: state.freightLabel,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CashMethodPage);
